/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

export const appContentContainer = css`
  position: relative;
  height: 100%;
  width: 100%;

  // this is important to allow flex
  // content to shrink when appropriate
  min-width: 0;

  @media (max-width: 900px) {
    width: 100%;
    margin-left: 0;
  }
`

export const appContainer = css`
  position: relative;
  display: flex;
  height: 100svh;
  width: 100%;
  overflow: hidden;
  @media (max-width: 900px) {
    width: 100%;
  }
`
